module.exports = __webpack_public_path__ + "static/img/logo28.9e74a7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo28.png
// module id = 9WCx
// module chunks = 1